import { gql } from '@apollo/client';
import permissions from '../../Apollo/permissions';
import { useMutation } from '../../index';

const MUTATION = gql`
  mutation OverrideOrganization($orgId: String!, $organizationName: String!) {
    auth0_override_organization(orgId: $orgId, organizationName: $organizationName) {
      status
    }
  }
`;

export default function useOverrideOrganization({ onCompleted, ...options } = {}) {
  const [callMutation, response] = useMutation(MUTATION, {
    context: { permission: permissions.overrideOrganization },
    onCompleted: data => {
      if (onCompleted) {
        onCompleted(getResponseBody({ data }));
      }
    },
    ...options,
  });

  const executeOperation = ({ orgId, organizationName }) => {
    if (!orgId) {
      return Promise.reject(new Error('orgId is required'));
    }
    if (!organizationName) {
      return Promise.reject(new Error('organizationName is required'));
    }
    return callMutation({
      variables: { orgId, organizationName },
    });
  };

  function getResponseBody(response) {
    return response.data.auth0_override_organization;
  }

  return [executeOperation, response];
}
